import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { settingsRoutes } from './routes'
import { settingsPath } from './index'
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths'

const wrappedSettingsRoutes = wrapRoutesWithRouter(settingsRoutes)
import { SettingsLayout } from './SettingsLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { TaskProvider } from '../shared/context/TaskContext'
import { PermissionGuard } from '../shared/components/NoPermission'
import { moduleAccess } from '../shared/permissions'

const SettingsModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
        <TaskProvider>
          <AppLayoutDahboardWithNav>
            <PermissionGuard companyId={companyId} {...moduleAccess.settings}>
              <ErrorBoundary
                fallback={(e) => (
                  <ErrorFallback error={e.error} onRetry={e.reset} />
                )}
              >
                <SettingsLayout companyId={companyId!}>
                  {/* `key` na firmie: strony ustawień trzymają wczytaną
                      konfigurację w lokalnym stanie, a zmiana firmy nie zmienia
                      dopasowanego wzorca trasy — bez tego komponent nie montuje
                      się ponownie i do czasu odpowiedzi (a przy jej błędzie —
                      na stałe) pokazuje dane poprzedniej firmy. */}
                  <Routes key={companyId}>
                    {wrappedSettingsRoutes.map((route) => (
                          <Route
                          key={route.path}
                          path={`${toRelativeRoute(route.path, settingsPath)}/*`}
                          element={<route.Component />}
                        />
                        ))}

                    {/* fallback */}
                    <Route path="*" element={<div>Select</div>} />
                  </Routes>
                </SettingsLayout>
              </ErrorBoundary>
            </PermissionGuard>
          </AppLayoutDahboardWithNav>
        </TaskProvider>
    </ErrorBoundary>
  )
}

export const SettingsModule = SettingsModuleImpl
